export default {
  namespaced: true,
  state: {
    files: [], // 存储文件列表
    folders: [], // 存储文件夹列表
    selectedFolder: null, // 当前选中的文件夹
    currentPage: 1, // 当前页码
    pageSize: 15, // 每页展示的条数（3行×5列）
    inputText: '', // 查询条件
  },
  mutations: {
    SET_FILES(state, files) {
      state.files = files;
    },
    SET_FOLDERS(state, folders) {
      state.folders = folders;
    },
    SET_SELECTED_FOLDER(state, folder) {
      state.selectedFolder = folder;
      state.currentPage = 1; // 切换文件夹时重置到第一页
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_PAGE_SIZE(state, size) {
      state.pageSize = size;
      state.currentPage = 1; // 修改每页条数时重置到第一页
    },
    SET_SEARCH_TEXT(state, value) {
      state.inputText = value;
      state.currentPage = 1; // 切换文件夹时重置到第一页
    },
  },
  actions: {
    initializeData({ commit }, { files, folders }) {
      commit('SET_FILES', files);
      commit('SET_FOLDERS', folders);
      commit('SET_SELECTED_FOLDER', null); // 默认选中第一个文件夹
    },
    updateSelectedFolder({ commit }, folder) {
      commit('SET_SELECTED_FOLDER', folder);
    },
    updateCurrentPage({ commit }, page) {
      commit('SET_CURRENT_PAGE', page);
    },
    updatePageSize({ commit }, size) {
      commit('SET_PAGE_SIZE', size);
    },
    updateSearchText({ commit }, size) {
      commit('SET_SELECTED_FOLDER', null);
      commit('SET_SEARCH_TEXT', size);
    },
  },
  getters: {
    // 筛选出当前选中文件夹的文件
    filteredFiles(state) {
      if (!state.selectedFolder) {
        return state.files.filter((file) => {
          // 如果有查询条件，筛选文件名是否包含查询条件
          const matchesSearch = !state.inputText || file.name.toLowerCase().includes(state.inputText.toLowerCase());
          return matchesSearch;
        });
      }
      return state.files.filter((file) => {
        const matchFolder = file.folder === state.selectedFolder;
        // 如果有查询条件，筛选文件名是否包含查询条件
        const matchesSearch = !state.inputText || file.name.toLowerCase().includes(state.inputText.toLowerCase());
        return matchesSearch && matchFolder;
      });
    },

    // 计算分页后的文件列表
    paginatedFiles(state, getters) {
      const start = (state.currentPage - 1) * state.pageSize;
      const end = start + state.pageSize;
      return getters.filteredFiles.slice(start, end);
    },

    // 计算总页数
    totalPages(state, getters) {
      return Math.ceil(getters.filteredFiles.length / state.pageSize);
    },

    // 计算文件总数
    totalFiles(state, getters) {
      return getters.filteredFiles.length;
    },
  },
};
